import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICheckLists } from "../interfaces/CheckLists";
import { ChecklistAnswers } from "../interfaces/Participants";
import { CHECKLIST_TYPE } from "../constants";

type ChecklistState = {
  isOpenChecklistPreviewDialog?: boolean;
  checklistId?: string;
  checklistData?: ICheckLists;
  checklistAnswers?: ChecklistAnswers;
  isEditMode?: boolean;
  disabled?: boolean;
  searchText?: string;
  pageSize?: number;
  pageNumber?: number;
  orderBy?: { field: string; sort: string };
  checklistType?: CHECKLIST_TYPE;
};
const initialState: ChecklistState = {
  isOpenChecklistPreviewDialog: false,
  checklistId: "",
  checklistData: undefined,
  checklistAnswers: undefined,
  isEditMode: false,
  disabled: false,
  searchText: "",
  pageSize: 50,
  pageNumber: 0,
  orderBy: { field: "lastUpdatedDate", sort: "desc" },
  checklistType: undefined
};

const checklistSlice = createSlice({
  name: "checklist",
  initialState,
  reducers: {
    onOpenChecklistPreviewDialog(
      state,
      action: PayloadAction<{
        id?: string;
        checklistData?: ICheckLists;
        isEditMode?: boolean;
        disabled?: boolean;
        checklistType?: CHECKLIST_TYPE;
      }>
    ) {
      state.isOpenChecklistPreviewDialog = true;
      state.checklistId = action.payload.id ?? "";
      state.checklistData = action.payload.checklistData ?? undefined;
      state.isEditMode = action.payload.isEditMode ?? false;
      state.disabled = action.payload.disabled ?? false;
      state.checklistType = action.payload.checklistType;
    },
    onCloseChecklistPreviewDialog(state) {
      state.isOpenChecklistPreviewDialog = false;
      state.checklistId = "";
      state.checklistData = undefined;
      state.checklistAnswers = undefined;
      state.isEditMode = false;
      state.disabled = false;
      state.checklistType = undefined;
    },
    onSaveChecklistAnswers(state, action: PayloadAction<ChecklistAnswers>) {
      state.checklistAnswers = action.payload;
    },
    onSetChecklistParams(
      state,
      action: PayloadAction<{
        searchText?: string;
        pageSize?: number;
        pageNumber?: number;
        orderBy?: { field: string; sort: string };
      }>
    ) {
      state.searchText = action.payload.searchText;
      state.pageSize = action.payload.pageSize;
      state.pageNumber = action.payload.pageNumber;
      state.orderBy = {
        field: action.payload.orderBy?.field || "lastUpdatedDate",
        sort: action.payload.orderBy?.sort || "desc"
      };
    }
  }
});

export const {
  onOpenChecklistPreviewDialog,
  onCloseChecklistPreviewDialog,
  onSaveChecklistAnswers,
  onSetChecklistParams
} = checklistSlice.actions;

export default checklistSlice.reducer;
